import React, { useState } from 'react';
import {
  FaQuestion,
  FaArrowRight,
  FaClock,
  FaUserShield
} from 'react-icons/fa';
import OndeConheceuModal from './modals/OndeConheceu';
import AgendaUnidadeModal from './modals/AgendaUnidade';
import { useNavigate } from 'react-router-dom';

const Configuracoes = () => {
  const [showOndeConheceuModal, setShowOndeConheceuModal] = useState(false);
  const [showAgendaUnidadeModal, setShowAgendaUnidadeModal] = useState(false);
  const navigate = useNavigate();

  const handleOpenOndeConheceuModal = () => {
    setShowOndeConheceuModal(true);
  };

  const handleCloseOndeConheceuModal = () => {
    setShowOndeConheceuModal(false);
  };

  const handleOpenAgendaUnidadeModal = () => {
    setShowAgendaUnidadeModal(true);
  };

  const handleCloseAgendaUnidadeModal = () => {
    setShowAgendaUnidadeModal(false);
  };

  const cards = [
    {
      title: 'Tipos de Acesso',
      description: 'Gerencie perfis de acesso e seus menus e submenus associados',
      icon: FaUserShield,
      action: () => navigate('/configuracoes/tipos-acesso'),
      active: true,
      color: '#6f42c1',
      bgColor: 'rgba(111, 66, 193, 0.1)'
    },
    {
      title: 'Agenda da Unidade',
      description: 'Configure os horários de funcionamento das unidades para agenda',
      icon: FaClock,
      action: handleOpenAgendaUnidadeModal,
      active: true,
      color: '#198754',
      bgColor: 'rgba(25, 135, 84, 0.1)'
    },
    {
      title: 'Onde Conheceu?',
      description: 'Configure as opções de como os clientes conheceram o estabelecimento',
      icon: FaQuestion,
      action: handleOpenOndeConheceuModal,
      active: true,
      color: '#0d6efd',
      bgColor: 'rgba(13, 110, 253, 0.1)'
    }
  ];

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body">
          <div className="row mt-3">
            <div className="col-12">
              <h4 className="fw-bold mb-0">
                Configurações do Sistema
              </h4>
            </div>
          </div>
          <div className="row mt-4 mb-4">
            {cards.map((card, index) => {
              const IconComponent = card.icon;
              return (
                <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4">
                  <div 
                    className={`card h-100 config-card ${card.active ? 'active' : 'disabled'}`}
                    style={{ 
                      cursor: card.active ? 'pointer' : 'not-allowed',
                      borderRadius: '12px',
                      overflow: 'hidden',
                      border: '1px solid #e0e0e0',
                      opacity: card.active ? 1 : 0.6,
                      transition: 'all 0.3s ease'
                    }}
                    onClick={() => card.active && card.action()}
                    onMouseEnter={(e) => {
                      if (card.active) {
                        e.currentTarget.style.transform = 'translateY(-4px)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                  >
                    <div className="card-body p-4">
                      <div className="d-flex align-items-center mb-3">
                        <div style={{ 
                          backgroundColor: card.bgColor, 
                          width: '70px', 
                          height: '70px',
                          minWidth: '70px',
                          borderRadius: '12px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: '20px'
                        }}>
                          <IconComponent size={32} style={{ color: card.color }} />
                        </div>
                        <div className="flex-grow-1">
                          <h5 className="card-title fw-bold mb-2">{card.title}</h5>
                        </div>
                      </div>
                      
                      <div className="d-flex justify-content-between align-items-end">
                        <p className="card-text text-muted mb-0 flex-grow-1">
                          {card.description}
                        </p>
                        {card.active && (
                          <div className="d-flex align-items-center text-primary ms-3">
                            <span className="me-2">Acessar</span>
                            <FaArrowRight 
                              size={14} 
                              style={{ 
                                transition: 'transform 0.3s ease'
                              }} 
                              className="arrow-icon"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      
      {showOndeConheceuModal && (
        <OndeConheceuModal onClose={handleCloseOndeConheceuModal} />
      )}
      
      {showAgendaUnidadeModal && (
        <AgendaUnidadeModal onClose={handleCloseAgendaUnidadeModal} />
      )}
    </div>
  );
};

export default Configuracoes; 